import React from 'react';
import { translate } from '@utils/i18n';
import { SyncStatusPanel } from '../SyncStatusPanel';
const NAMESPACE = 'features.settings.integrations.qbo_sync_status_panel';
/**
 * Page-level wrapper island for the QBO Sync Status panel.
 * Mounts via react_component('Settings/Integrations/QboSyncStatusPanel').
 */
function QboSyncStatusPanel() {
    const rows = [
        { category: 'payments', label: translate('row_payments', { namespace: NAMESPACE }), syncable: false },
        { category: 'customers', label: translate('row_customers', { namespace: NAMESPACE }), syncable: true },
        { category: 'materials', label: translate('row_materials', { namespace: NAMESPACE }), syncable: true },
        { category: 'tax_rates', label: translate('row_tax_rates', { namespace: NAMESPACE }), syncable: true }
    ];
    return (React.createElement(SyncStatusPanel, { integration: "qbo", title: translate('title', { namespace: NAMESPACE }), subtitle: translate('subtitle', { namespace: NAMESPACE }), rows: rows, footerActivityCategory: "webhooks", footerNote: translate('footer_note', { namespace: NAMESPACE }), healthyLabel: translate('healthy_label', { namespace: NAMESPACE }) }));
}
export default QboSyncStatusPanel;
